<template>
	<layout-page title="Bulk bid">
		<div class="flex-grow flex flex-col bg-gray-100">
			<!-- header -->
			<div
				class="bg-green px-6 py-4 md:rounded-tl-2xl md:rounded-tl-2xl xl:rounded-t-2xl flex justify-start"
			>
				<h1 class="text-4xl font-semibold text-white">{{ __("Bulk bid") }}</h1>
			</div>

			<div
				class="px-4 sm:px-6 lg:px-6 py-4 bg-gray-700 md:space-y-0 flex-wrap flex justify-between items-center md:space-x-6 text-white"
			>
				{{ __("My buy offer") }}
			</div>
			<div class="p-6">
				<my-lots-card
					:offer="offer"
					:show-action-buttons="false"
					:auctionMyLotsState="auctionMyLotsState"
				/>
			</div>

			<div
				class="px-4 sm:px-6 lg:px-6 py-4 bg-gray-700 md:space-y-0 flex-wrap flex justify-between items-center md:space-x-6 text-white"
			>
				{{ __("Matching offer for your demand") }}
			</div>

			<div
				class="px-4 sm:px-6 lg:px-6 py-4 bg-gray-700 md:space-y-0 flex-wrap flex justify-between items-center md:space-x-6"
			>
				<div
					class="order-1 md:order-2 lg:order-3 mb-4 md:mb-0 flex items-center space-x-4 text-gray-100 w-full md:w-auto"
				>
					<ui-check-box-select
						class="grid-cols-2 sm:grid-cols-3 text-sm"
						v-model="filter.sellerType"
						:options="sellerTypeOptions"
					/>
				</div>
			</div>

			<div class="flex flex-col p-6 gap-y-6">
				<!-- ? table -->
				<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
					<div
						class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
					>
						<div
							class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
						>
							<table class="min-w-full divide-y divide-gray-200 bg-white">
								<thead class="bg-gray-50">
									<tr>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
										>
											{{ __("Status") }}
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
										>
											{{ __("User type") }}
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
										>
											{{ __("Article") }}
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
										>
											{{ __("Location") }}
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
										>
											{{ __("Distance") }}
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
										>
											{{ __("Freight cost") }}
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
										>
											{{ __("Quantity") }}
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
										>
											{{
												offer.price.type == "FLAT"
													? __("Price offer")
													: __("Basis")
											}}
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
											v-if="['BASIS', 'INDEXED'].includes(offer.price.type)"
										>
											{{ __("Price Indication") }}
										</th>
									</tr>
								</thead>

								<tbody class="divide-y divide-gray-200">
									<bulk-bid-item
										v-for="(match, idx) in form.matches"
										:key="'MATCH_' + match.id + '_' + bidsToBeSubmitted.number"
										:form="form"
										:match="match"
										:idx="idx"
										:offer="offer"
										:bidsToBeSubmitted="bidsToBeSubmitted"
									/>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<div class>
					<ui-button
						:key="'BUTTON_' + 'bids'"
						class="text-lg"
						:label="
							__('messages.bid_button', {
								args: { count: bidsToBeSubmitted.number },
								pluralize: true,
							})
						"
						v-on:click="submitForm()"
						:disabled="submitButtonDisabled"
					/>
				</div>
			</div>
		</div>
	</layout-page>
</template>

<script>
import Vue from "vue";
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		matches: {
			type: Array,
			required: false,
		},
		auctionMyLotsState: {
			required: false,
			type: String,
		},
	},
	data() {
		let offerPriceType = this.offer.price.type,
			commodityFuture = null;
		if (this.offer.commodityFuture) {
			commodityFuture = this.offer.commodityFuture.id;
		}
		let allMatches = this.matches.map(function (r) {
			return Object.assign({
				input: {
					placeBid: false, // r.distance_km_road < 250 ? true : false,
					price__type: offerPriceType,
					price__mt: null,
					price__basis: null,
					qty__mt: r.offer.qty.mt,
					price__commodity_future_id: commodityFuture,
				},
				freight_cost_eur: r.freight_cost_eur,
				distance_km_road: r.distance_km_road,
				threads: r.threads,
				id: r.id,
				offer: {
					id: r.offer.id,
					user: { type: r.offer.user.type },
					product: r.offer.product,
					location: r.offer.location,
					trade: r.offer.trade,
					qty: r.offer.qty,
				},
			});
		});

		//  commodityFuture = this.offer.commodityFuture.id;
		return {
			filter: {
				sellerType: [],
			},
			allMatches: allMatches,
			form: Vue.observable(
				this.$inertia.form({
					matches: this.allMatches,
					source_offer_trade: this.offer.trade,
					source_offer_id: this.offer.id,
				})
			),
			submitButtonDisabled: false,

			bidsToBeSubmitted: {
				number: allMatches.filter((m) => m.input.placeBid == true).length,
			},
		};
	},
	methods: {
		submitForm() {
			console.log("SUBMIT");
			let that = this;

			this.form.submit("patch", this.$page.url, {
				//preserveState: true,
				preserveScroll: true,
				onFinish() {
					that.allMatches.forEach((value) => {
						value.input.placeBid = false;
					});
				},
			});
			console.log("DONE");
			// window.location.reload();
		},
	},
	computed: {
		sellerTypeOptions() {
			return this.$cropOptions.companyTypeOptions.map(function (o) {
				return { label: o.name, value: o.id };
			});
		},
	},
	watch: {
		filter: {
			handler() {
				let filter = this.filter;
				this.form.matches = this.allMatches.filter(function (m) {
					if (filter.sellerType.length > 0) {
						return filter.sellerType.includes(m.offer.user.type);
					} else {
						return true;
					}
				});
			},
			deep: true,
			immediate: true,
		},
		matches: {
			handler() {
				this.allMatches.forEach((value, index) => {
					value.threads = this.matches[index].threads;
				});
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>
